import styled from 'styled-components';
import slide1 from 'assets/images/desktop/slide1.png';
import { fonts } from 'styles';

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 80px 24px;
`;

export const Image = styled.img.attrs({ src: slide1 })`
  width: 100%;
  max-width: max-content;
  margin-bottom: 128px;

  @media screen and (min-width: 1920px) {
    margin-bottom: 200px;
  }
`;

export const Credits = styled.div`
  font-family: ${fonts.BentonSansRegular};
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  color: #fff;
  text-align: center;
`;
